module.exports = __webpack_public_path__ + "static/media/bowling.8de8e00e.svg";